<template>
	<v-layout row wrap v-if="wasModified() || !old || !otherCost">
		<v-flex d-flex xs1>
			<v-card :color=" color() + ' lighten-2'">
				<v-card-text class="px-2"><strong>{{serialNumber ? serialNumber + "." : ""}}
					{{cost.serialNumber}} {{status()}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :style="namesDifferent() ? changedStyle() : ''">
				<v-card :color="(namesDifferent() ? color() : 'grey') + ' lighten-3'">
					<v-card-text class="px-2"><strong>{{cost.name}}</strong>
					</v-card-text>
				</v-card>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(unitsCountDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{cost.unitsCount}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(pricePerUnitDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.pricePerUnit)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(measureTypeDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{cost.measureType}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(totalPriceDifferent() ? color() : 'grey') + ' lighten-2'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.totalPrice)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(fromDotationDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromDotation)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(fromOtherDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOther)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(fromOwnHumanDifferent() ? color() : 'grey') + ' lighten-3'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOwnHuman)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card>
				<v-card :color="(fromOwnFinancialDifferent() ? color() : 'grey') + ' lighten-3'">
					<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOwnFinancial)}}</v-card-text>
				</v-card>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	import {Numbers} from "../../../../../utils/Numbers";

	export default {
		name: 'compare-costs-calculated-single-cost',
		props: {
			serialNumber: {},
			old: Boolean,
			cost: {},
			otherCost: {},
		},
		mixins: [Numbers],

		computed: {},

		methods: {

			changedStyle () {
				return "darken-3";
			},

			propertiesDifferent (getter) {
				if (!this.otherCost) {
					return true;
				}
				return getter(this.otherCost) !== getter(this.cost);
			},

			status () {
				if (!this.otherCost) {
					return this.old ? '(Usunięty)' : '(Nowy)';
				}
				return this.wasModified() ? (this.old ? "(Było)" : "(Jest)") : '';
			},

			wasModified () {
				if (!this.otherCost) {
					return false;
				}
				return this.fromDotationDifferent() ||
					this.fromOtherDifferent() ||
					this.fromOwnHumanDifferent() ||
					this.fromOwnFinancialDifferent() ||
					this.namesDifferent() ||
					this.measureTypeDifferent() ||
					this.pricePerUnitDifferent() ||
					this.unitsCountDifferent();
			},

			pricePerUnitDifferent () {
				return this.propertiesDifferent(x => x.pricePerUnit);
			},

			measureTypeDifferent () {
				return this.propertiesDifferent(x => x.measureType);
			},

			totalPriceDifferent () {
				return this.propertiesDifferent(x => x.totalPrice);
			},

			fromOwnHumanDifferent () {
				return this.propertiesDifferent(x => x.fromOwnHuman);
			},

			fromOtherDifferent () {
				return this.propertiesDifferent(x => x.fromOther);
			},

			fromOwnFinancialDifferent () {
				return this.propertiesDifferent(x => x.fromOwnFinancial);
			},

			fromDotationDifferent () {
				return this.propertiesDifferent(x => x.fromDotation);
			},

			namesDifferent () {
				return this.propertiesDifferent(x => x.name);
			},

			unitsCountDifferent () {
				return this.propertiesDifferent(x => x.unitsCount);
			},

			color () {
				if (!this.otherCost) {
					return this.old ? 'red' : 'green';
				}
				return this.wasModified() ? "blue" : "gray";
			}

		}
	};
</script>